// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2WkxU","alertIcon":"ConfirmModal_alertIcon__1Oq63"};